import cx from "@hsl/core/utils/cx";

import useExplorerStore from "../../../store/store";

interface Props {
    text: string;
    className?: string;
    children?: React.ReactNode;
}
export default function HighlightOnMatch({ text, children, className }: Props) {
    const searchResults = useExplorerStore((state) => state.search.rawResults);
    const matches = searchResults.flatMap((result) =>
        result.matches?.map((match) => match.value),
    );
    const isMatch = matches.includes(text);
    return (
        <span
            className={cx([className, { "bg-yellow-200 font-bold": isMatch }])}
        >
            {children ?? text}
        </span>
    );
}
